<template>
  <div>
    <sites-list :sites="sites"/>
  </div>
</template>

<script>
import SitesList from "../../components/sites/sites-list";
import sitesApi from "../../api/sites";

export default {
  data() {
    return {
      sites: []
    };
  },

  components: {
    "sites-list": SitesList
  },

  created() {
    var that = this;
    sitesApi
      .getSites()
      .then(function(response) {
        that.sites = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
</style>
